import { useState, useEffect, useCallback } from 'react'
import { useGameStore } from '@store/gameStore'
import './AdModal.css'

// YouTube Video IDs for ads (30 seconds each)
const AD_VIDEOS = [
    'Owl6Rs2LuHE',
    'xhA-uPPGpiM',
    'FuYbbU_6Gjk',
    'pWMUGH5y-l4',
    'LTwruoKHXxk',
    'HGi-FY_GZME',
    'ay1dFRKA6lw',
    'jeMDLRontGI',
    'vt2lWFa1ZZ4',
    'g9z3G-duHdQ',
    'SvHtoUQOz0A',
    'Sgx70bM4N4s',
]

interface AdModalProps {
    onComplete: () => void
    onCancel: () => void
}

export function AdModal({ onComplete, onCancel }: AdModalProps) {
    const [timeRemaining, setTimeRemaining] = useState(30)
    const [isClosing, setIsClosing] = useState(false)
    const [videoId] = useState(() => AD_VIDEOS[Math.floor(Math.random() * AD_VIDEOS.length)])

    const trackAdWatched = useGameStore(state => state.trackAdWatched)

    // Stable countdown timer
    useEffect(() => {
        const timer = setInterval(() => {
            setTimeRemaining(prev => {
                if (prev <= 0) {
                    clearInterval(timer)
                    return 0
                }
                return prev - 1
            })
        }, 1000)

        return () => clearInterval(timer)
    }, [])

    // Completion logic with 2s grace period
    useEffect(() => {
        if (timeRemaining <= 0 && !isClosing) {
            setIsClosing(true)

            // Note: We don't return the clearTimeout here because 
            // the state update (setIsClosing) triggers a re-render 
            // which would immediately execute the cleanup and cancel our timer.
            setTimeout(() => {
                trackAdWatched()
                onComplete()
            }, 1000)
        }
    }, [timeRemaining, isClosing, onComplete, trackAdWatched])

    const handleAbort = useCallback(() => {
        onCancel()
    }, [onCancel])

    return (
        <div className="ad-modal">
            <div className="ad-modal__header">
                <span className="ad-modal__sponsor">Gesponsert</span>
                <span className="ad-modal__timer">
                    {timeRemaining > 0 ? `⏳ ${timeRemaining}s` : '✅ Abgeschlossen'}
                </span>
            </div>

            <div className="ad-modal__video">
                <iframe
                    src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0&controls=0&modestbranding=1&rel=0&showinfo=0`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Werbung"
                />
            </div>

            <div className="ad-modal__footer">
                <button className="ad-modal__abort" onClick={handleAbort}>
                    ✕ Abbrechen (keine Belohnung)
                </button>
                <span className="ad-modal__hint">
                    Werbung ansehen für Gratis-Boost!
                </span>
            </div>
        </div>
    )
}
